// extracted by mini-css-extract-plugin
module.exports = {"TypeformContainer":"TypeformPage_TypeformContainer__vqRA0"};